import type {
  CalendarComponentEvent,
  CalendarPermissions,
} from '@axiom/validation';

import { EVENT_STATES } from './calendar-events.const';

export const useCalendarAccessors = (
  permissions: CalendarPermissions,
  editableEventId?: string | null
) => {
  const handleDraggableAccessor = (event: CalendarComponentEvent) => {
    return editableEventId == null
      ? (event.busy &&
          event.state !== EVENT_STATES.SAVED &&
          permissions.staticEvent.canMove) ||
          (!event.busy && permissions.eventBoundary.canMove)
      : event.id === editableEventId;
  };

  const handleResizableAccessor = (event: CalendarComponentEvent) => {
    return editableEventId == null
      ? (event.busy &&
          event.state !== EVENT_STATES.SAVED &&
          permissions.staticEvent.canResize) ||
          !event.busy
      : event.id === editableEventId;
  };

  return {
    handleDraggableAccessor,
    handleResizableAccessor,
  };
};
